module.exports = __webpack_public_path__ + "media/loading-logo.ddf1ffc5.gif";